import React from 'react'
import PropTypes from 'prop-types'

import FlatButton from 'material-ui/FlatButton'

const ConfirmationModal = ({
  closeConfirmationModal,
  handleTemplateConfirmation,
  selectionType,
  templateName,
}) => {
  return (
    <div>
      <div style={{ paddingBottom: '8px' }}>
        <p>
          {`Are you sure you want to ${selectionType} your saved template '${templateName}'?`}
        </p>
      </div>
      <FlatButton onClick={closeConfirmationModal} label="Cancel" />
      <FlatButton
        onClick={handleTemplateConfirmation}
        label={selectionType}
        primary
      />
    </div>
  )
}

ConfirmationModal.propTypes = {
  closeConfirmationModal: PropTypes.func.isRequired,
  handleTemplateConfirmation: PropTypes.func.isRequired,
  selectionType: PropTypes.string,
  templateName: PropTypes.string,
}

export default ConfirmationModal



// WEBPACK FOOTER //
// ./src/components/Messages/MessagesEditor/ConfirmationModal.js